"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.baseLinkStyles = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _reactRouterDom = require("react-router-dom");
var _reactTracking = require("react-tracking");
var _Button = require("../button/Button");
const baseLinkStyles = _ref => {
  let {
    theme,
    color,
    fontSize,
    fontWeight,
    textDecoration
  } = _ref;
  return {
    textAlign: 'center',
    color: (theme === null || theme === void 0 ? void 0 : theme.colors[color !== null && color !== void 0 ? color : '']) || (theme === null || theme === void 0 ? void 0 : theme.colors.textPrimary),
    textDecoration: textDecoration || 'underline',
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'none'
    },
    fontSize: (theme === null || theme === void 0 ? void 0 : theme.fontSizes[fontSize]) || 'normal',
    ...(fontWeight && {
      fontWeight: theme === null || theme === void 0 ? void 0 : theme.fontWeights[fontWeight !== null && fontWeight !== void 0 ? fontWeight : '']
    })
  };
};
exports.baseLinkStyles = baseLinkStyles;
const StyledLink = _styled.default.a(_ref2 => {
  let {
    color,
    fontSize,
    fontWeight,
    button,
    textDecoration,
    theme
  } = _ref2;
  let buttonStyles = {};
  if (button === 'primary' || button === 'secondary') {
    buttonStyles = {
      ...(0, _Button.baseButtonStyles)(theme),
      ...(0, _Button.getStylesByVariant)({
        color: button,
        theme
      })
    };
  }
  return {
    ...baseLinkStyles({
      theme,
      color,
      fontSize,
      fontWeight,
      textDecoration
    }),
    ...buttonStyles
  };
});
const Link = _ref3 => {
  let {
    activeClassName = 'selected',
    activeStyle = {},
    button,
    children,
    className = '',
    color,
    exact = false,
    fontSize = 'normal',
    fontWeight,
    id = '',
    linkType = 'internal',
    onClick = () => {},
    name,
    newTab = false,
    path,
    strict = false,
    textDecoration = 'underline',
    ...rest
  } = _ref3;
  const history = (0, _reactRouterDom.useHistory)();
  const {
    trackEvent
  } = (0, _reactTracking.useTracking)();
  const handleClick = event => {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    trackEvent({
      event_name: `${name}-${button ? 'button' : 'link'}`,
      event_type: 'click'
    });
    onClick(event);
    if (newTab) {
      window.open(path);
    } else if (linkType === 'external') {
      window.location.href = path;
    } else {
      history === null || history === void 0 ? void 0 : history.push(path);
    }
  };
  const additionalProps = {
    internal: {
      as: path !== '' ? _reactRouterDom.Link : undefined,
      to: path
    },
    nav: {
      activeClassName,
      activeStyle,
      as: _reactRouterDom.NavLink,
      exact,
      strict,
      to: path
    },
    external: {
      href: path,
      role: 'link',
      tabIndex: 0,
      target: newTab ? '_blank' : '_self'
    }
  };
  return /*#__PURE__*/_react.default.createElement(StyledLink, Object.assign({
    button: button,
    className: className,
    color: color,
    fontSize: fontSize,
    fontWeight: fontWeight,
    id: id,
    textDecoration: textDecoration,
    onClick: handleClick,
    onMouseDown: rest === null || rest === void 0 ? void 0 : rest.onMouseDown
  }, additionalProps[linkType], {
    tabIndex: rest.tabIndex
  }), children);
};
var _default = exports.default = Link;